export const scorecard = {
  complete: 'Sections complete',
  pvqComplete: 'Modules complete',
};
